import Button from '@jetbrains/ring-ui/components/button/button'
import plur from 'plur'
import {Suspense, useReducer} from 'react'

import {EntityProvider} from '../../../../contexts/entity'
import {restApi} from '../../../../services/rest'
import {emptyArray} from '../../../../utils/empty'
import Loader from '../../../common/Loader/Loader'

import BuildTypeChainBlock from './BuildTypeChainBlock/BuildTypeChainBlock'
import {useBuildTypeChainsArg} from './BuildTypeChainsTab.rest'

import styles from './BuildTypeChainsTab.css'

const INITIAL_COUNT = 20
export default function BuildTypeChainsTab() {
  const [count, loadMore] = useReducer(state => state + INITIAL_COUNT, INITIAL_COUNT)
  const {buildIds, isLoading, isLoadingMore} = restApi.endpoints.getAllBuildsNormalized.useQuery(
    useBuildTypeChainsArg(count),
    {
      selectFromResult: ({data, currentData, isLoading}) => ({
        buildIds: data?.result ?? emptyArray,
        isLoading,
        isLoadingMore: data !== currentData,
      }),
    },
  )
  const loadedCount = isLoadingMore ? count - INITIAL_COUNT : count
  const hasMore = buildIds.length > loadedCount

  return isLoading ? (
    <Loader />
  ) : (
    <Suspense fallback={<Loader />}>
      <div className={styles.note}>
        {hasMore
          ? `Showing ${loadedCount} most recent build chains.`
          : `Found ${buildIds.length} build ${plur('chain', buildIds.length)}.`}
      </div>
      <div className={styles.blocks}>
        {buildIds.slice(0, loadedCount).map(buildId => (
          <EntityProvider key={buildId} buildId={buildId}>
            <BuildTypeChainBlock />
          </EntityProvider>
        ))}
      </div>
      {hasMore && (
        <Button className={styles.loadMore} onClick={loadMore} loader={isLoadingMore}>
          {'More'}
        </Button>
      )}
    </Suspense>
  )
}
